module.exports = __webpack_public_path__ + "1cfb9f5eaf00036c160b27213cdc6a28.pdf";